import React from 'react';
import { StatCard } from '../../components/common/StatCard';
import { useStaggeredEntrance } from '../../hooks/useStaggeredEntrance';
import { ForgeStatCard } from '../../types';

const DASHBOARD_STATS: ForgeStatCard[] = [
  { label: 'Total Tasks Today', value: 312, format: 'number', diff: 45, diffLabel: 'vs yesterday', accent: true },
  { label: 'Avg Accuracy', value: 91.8, format: 'percent', diff: -0.4, diffLabel: 'vs last week' },
  { label: 'Queue Backlog', value: 270, format: 'number', diff: -38, diffLabel: 'vs morning' },
];

const LEADERBOARD = [
  { name: 'Alice Chen', tasks: 142, accuracy: '97%' },
  { name: 'Frank Liu', tasks: 112, accuracy: '93%' },
  { name: 'Bob Martinez', tasks: 98, accuracy: '94%' },
  { name: 'Grace Okafor', tasks: 88, accuracy: '91%' },
];

export const ForgeDashboardPage: React.FC = () => {
  const visibility = useStaggeredEntrance(5, 50);

  return (
    <div className="page-content">
      <div className="stats-row" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {DASHBOARD_STATS.map((stat, i) => (
          <StatCard key={stat.label} stat={stat} isVisible={visibility[i]} />
        ))}
      </div>

      <div style={{ opacity: visibility[3] ? 1 : 0, transform: visibility[3] ? 'translateY(0)' : 'translateY(8px)', transition: 'opacity 350ms ease, transform 350ms ease' }}>
        <div className="forge-card" style={{ marginBottom: 20 }}>
          <div className="forge-card-title">Leaderboard — Today</div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Labeler</th>
                <th>Tasks</th>
                <th>Accuracy</th>
              </tr>
            </thead>
            <tbody>
              {LEADERBOARD.map((row, i) => (
                <tr key={row.name}>
                  <td style={{ fontFamily: 'var(--font-mono)', fontWeight: 600 }}>#{i + 1}</td>
                  <td style={{ fontWeight: 600 }}>{row.name}</td>
                  <td style={{ fontFamily: 'var(--font-mono)' }}>{row.tasks}</td>
                  <td style={{ fontFamily: 'var(--font-mono)' }}>{row.accuracy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ opacity: visibility[4] ? 1 : 0, transform: visibility[4] ? 'translateY(0)' : 'translateY(8px)', transition: 'opacity 350ms ease, transform 350ms ease' }}>
        <div className="forge-card">
          <div className="forge-card-title">Queue Backlogs</div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Queue</th>
                <th>Pending</th>
                <th>Processed Today</th>
                <th>Est. Clearance</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontWeight: 600 }}>Uncertain Classification</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>567</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>251</td>
                <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--danger)' }}>~3h</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 600 }}>Design Curator</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>466</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>124</td>
                <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--warning)' }}>~2h</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 600 }}>FD Classification</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>134</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>56</td>
                <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--text-secondary)' }}>event</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 600 }}>Design Review</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>312</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>98</td>
                <td style={{ fontFamily: 'var(--font-mono)', color: 'var(--warning)' }}>~3h</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
